import Checkbox from '@material-ui/core/Checkbox';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente StyledTreeView
 */
export const StyledTreeView = styled(TreeView)`
  height: 216px;
  flex-grow: 1;
  max-width: 400px;

  .Mui-expanded {
    height: auto;
    display: contents;
  }

  .MuiTreeItem-group {
    margin-left: 0px;
  }
`;

/**
 * Estilização do componente BaseTreeItem
 */
const BaseTreeItem = styled(TreeItem)`
  box-sizing: border-box;

  li.MuiTreeItem-root {
  }

  &.Mui-expanded {
    .MuiTreeItem-content {
      color: #3c71dd;
    }
  }

  .MuiTreeItem-content {
    position: relative;
    left: -5px;
    height: 100%;
  }

  .MuiTreeItem-label {
    padding-left: 0px;
    height: 100%;
    font-size: 14px !important;
    line-height: 16px !important;
  }

  .MuiTreeItem-iconContainer {
    width: 0px;
  }

  .custom_tree_item {
    position: relative;
    height: 100%;
    padding: 8px 0;

    @media (min-width: 768px) {
      width: 306px;
    }
  }
`;

/**
 * Estilização do componente StyledTreeCategory
 */
export const StyledTreeCategory = styled(BaseTreeItem)`
  .MuiTreeItem-content {
    height: 44px;
    transition: margin-bottom 100ms;
  }
  li[tabindex='0']:not([aria-expanded]) p:not(.custom_tree_subcategory) {
    color: #3c71dd;
  }
  //category
  .custom_tree_item.category {
    border-bottom: 1px solid #ccc;
    background-color: #fff;
  }
  .custom_tree_item.category:hover {
    background-color: #f1f5ff !important;
  }

  &.Mui-expanded {
    .MuiTreeItem-content {
      margin-bottom: 0px;
      color: #5e5e5e;
    }
    .MuiTreeItem-label {
      background-color: #e6eeff !important;
    }
    //category
    .custom_tree_item.category {
      background-color: #f1f5ff;
      /* border-bottom: 0.5px solid #aac6ff; */
    }
  }

  .Mui-expanded {
    .MuiTreeItem-content {
      margin-bottom: 0px;
      color: #5e5e5e;
    }
    > .MuiTreeItem-content > .MuiTreeItem-label {
      background-color: #e6eeff !important;
    }
    .MuiTreeItem-label {
      //layers
      background-color: #dbe7ff !important;
    }
    .Mui-selected > .MuiTreeItem-content > .MuiTreeItem-label {
      background-color: #dbe7ff !important;
    }
  }

  .custom_tree_item {
    padding: 8px 10px 8px 5px;
    /* font-weight: bold; */
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .expandedIcon {
    position: absolute;
    transition: 0.5s all;
    right: 12px;
    transform-origin: center;
    transform: ${({ expanded }) =>
      expanded ? 'rotate(-180)' : 'rotate(180deg)'};
  }
`;

/**
 * Estilização do componente StyledTreeSubcategory
 */
export const StyledTreeSubcategory = styled(BaseTreeItem)`
  .MuiTreeItem-content {
    height: 44px;
    transition: margin-bottom 100ms;
  }

  &.Mui-expanded {
    .custom_tree_item.subcategory {
      border-bottom: 0.5px solid #aac6ff;
    }
    .MuiTreeItem-content {
      margin-bottom: 0px;
      color: #5e5e5e;
    }
    > .MuiTreeItem-content > .MuiTreeItem-label {
      background-color: #e6eeff !important;
    }
    .MuiTreeItem-label {
      background-color: #dbe7ff;
    }
  }

  .custom_tree_item {
    padding: 8px 10px 8px 18px;
    font-weight: normal;
  }

  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
    margin: 0;
    width: 90%;
  }

  li .custom_tree_subcategory {
    padding-left: 4px;
  }

  li[tabindex='0']:not([aria-expanded]) p:not(.custom_tree_subcategory) {
    color: #3c71dd;
  }

  .expandedIcon {
    position: absolute;
    transition: 0.5s all;
    top: 8px;
    right: 12px;
    transform-origin: center;
    transform: ${({ expanded }) =>
      expanded ? 'rotate(-180)' : 'rotate(180deg)'};
  }
`;

/**
 * Estilização do componente StyledCheckbox
 */
export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-colorPrimary.Mui-checked {
    color: #3c71dd;

    /* Ignorar a cor do ícone raiz quando o checkbox estiver marcado */
    .MuiSvgIcon-root {
      color: #3c71dd; /* Inherit vai herdar a cor definida acima */
      fill: #3c71dd; /* Isso vai ignorar o preenchimento personalizado */
    }

    .MuiSvgIcon-fontSizeSmall {
      background-color: #ffffff; /* Fundo branco */
      border: 1px solid #c0c0c0; /* Borda cinza clara */
      font-size: 1rem;
    }
  }

  .MuiSvgIcon-fontSizeSmall {
    background-color: #ffffff; /* Fundo branco */
    border: 1px solid #c0c0c0; /* Borda cinza clara */
    font-size: 0.8rem;
  }

  .MuiSvgIcon-root {
    color: #3c71dd;
    fill: none;
  }

  /* Ajuste da posição do checkbox */
  transform: translateY(-5px); /* Move o checkbox 2px para cima */
`;

export const StyledTreeItem = styled(BaseTreeItem)`
  .MuiTreeItem-content {
    margin-bottom: 0px !important;
    height: 54px; // Aumenta a altura aqui
  }

  .custom_tree_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 1px 10px 18px; // Ajusta o padding conforme necessário
  }

  p {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
    margin: 0;
    width: 85%;
    padding-left: 17px;
    padding-bottom: 8px;
  }
`;
